/**
 * 工具设置
 *
 * @export
 * @class ToolOption
 * @author zhenliang.sun
 */
export default class ToolOption {
  constructor() {
    this.stroke = '#000000';
    this.strokeWidth = 4;
    this.fill = '';
  }
}
